import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { AUTH_COOKIE } from '../helpers/Constants'
import { decodeAuthCookie } from '../helpers/authCookie'
import { clearSession, isSessionRejected } from '../helpers/session'

const MOCK_USER = {
    email: 'dev@bhanzu.com',
    name: 'Dev User',
    permissions: ['dev-admins'],
}

// Mock auth can never activate in a production build, even if the env var
// leaks into the build environment.
const isMockAuth =
    process.env.NODE_ENV !== 'production' &&
    process.env.REACT_APP_MOCK_AUTH === 'true'

const useAuth = () => {
    const navigate = useNavigate()

    if (isMockAuth) {
        return { user: MOCK_USER, logout: () => {} }
    }

    const raw = Cookies.get(AUTH_COOKIE)
    // A cookie the API has already rejected (401) is signed out, even if it
    // still decodes as fresh here. See helpers/session.js.
    const user = isSessionRejected(raw) ? {} : decodeAuthCookie(raw)
    // Every session cookie on every domain it may be on (helpers/session.js).
    const logout = () => {
        clearSession()
        navigate('/login')
    }
    return { user, logout }
}

export default useAuth
